import { render, staticRenderFns } from "./LiquidationsTable.vue?vue&type=template&id=52c5a849&"
import script from "./LiquidationsTable.vue?vue&type=script&lang=js&"
export * from "./LiquidationsTable.vue?vue&type=script&lang=js&"
import style0 from "./LiquidationsTable.vue?vue&type=style&index=0&id=52c5a849&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports